import React from "react";
import {
  makeStyles,
  ButtonBase,
  Typography,
  Button,
  Box
} from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    padding: "0.25em 0.75em",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 4,
    border: "1px solid #D0D5DD",
    width: "100%",
    height: "2.75em",
    overflow: "hidden"
  },
  inputText: {
    fontSize: "1rem",
    color: "#a4a6a8",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  filled: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  clearButton: {
    minWidth: 0
  }
}))

export default function BranchSingleFlatSelectComponent({
  handleClick,
  handleClear,
  value,
  placeholder,
  disabled,
  style,
  isEmpty,
  id,
  open,
  textStyle,
  isClearable
}) {
  const classes = useStyles();
  
  const displayValue = () => {
    if (isEmpty) {
      return placeholder
    }

    if (value !== undefined || value !== null){
      return value.name
    }
    return undefined
  }

  return (
    <ButtonBase
      aria-describedby={id}
      className={classes.root}
      disableRipple
      onClick={handleClick}
      disabled={disabled}
      style={{ paddding: 12, ...style }}
    >
      <Typography
        variant='body2'
        className={clsx(classes.inputText, {
          [classes.filled]: !isEmpty
        })}
        style={textStyle}
      >
        {displayValue()}
      </Typography>
      <Box 
        style={{
          display: "flex",
          alignItems: "center"
        }}
      >
        {isClearable && !isEmpty &&
          <Button
            className={classes.clearButton}
            onClick={(e) => {
              e.stopPropagation()
              handleClear()
            }}
          >
            <ClearIcon style={{ fontSize: 16 }} />
          </Button>
        }
        {!disabled && (open ? (
          <ArrowDropUpIcon fontSize='small' />
        ) : (
          <ArrowDropDownIcon fontSize='small' />
        ))}
      </Box>
    </ButtonBase>
  )
}